import { BitrixVue } from 'ui.vue3';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

export const CheckboxItem = {
    props: {
        item: [Object],
        open: [Boolean, undefined]
    },
    updated(){
        let tableContainer = $(this.$el).find('.js-filter-list-wp');
        let blockDisplay = tableContainer.css('display');
        let filterList = tableContainer.find('.js-filter-list');
        let itemsHeight = 0,
            countItems = tableContainer.find('.js-filter-list-item').length,
            maxCount = 5;

        tableContainer.show();
        for (let i = 0; i < maxCount; i++) {
            // Получаем высоту первых 5 элементов
            if(tableContainer.find('.js-filter-list-item').eq(i).length){
                itemsHeight += tableContainer.find('.js-filter-list-item').eq(i).outerHeight();
            }
        }
        tableContainer.css('display', blockDisplay);

        if (countItems > maxCount && !filterList.hasClass('is-hidden')) {
            // Скрываем элементы при инциализации
            filterList.css('height', itemsHeight);
            filterList.css('overflow', 'hidden');
            filterList.addClass('is-hidden');
            filterList.css('opacity', '1');
        } else if (itemsHeight !== filterList.outerHeight() && filterList.hasClass('is-hidden')) {
            filterList.css('height', itemsHeight);
        } else {
            filterList.css('opacity', '1');
            if(countItems <= maxCount)
                tableContainer.find('.js-filter-list-show').addClass('is-hidden');
        }
    },
    mounted(){

        let tableContainer = $(this.$el).find('.js-filter-list-wp');
        let blockDisplay = tableContainer.css('display');
        let filterList = tableContainer.find('.js-filter-list');
        let itemsHeight = 0,
            countItems = tableContainer.find('.js-filter-list-item').length,
            maxCount = 5;

        tableContainer.show();
        for (let i = 0; i < maxCount; i++) {
            // Получаем высоту первых 5 элементов
            if(tableContainer.find('.js-filter-list-item').eq(i).length){
                itemsHeight += tableContainer.find('.js-filter-list-item').eq(i).outerHeight();
            }
        }
        tableContainer.css('display', blockDisplay);

        if (countItems > maxCount && !filterList.hasClass('is-hidden')) {
            // Скрываем элементы при инциализации
            filterList.css('height', itemsHeight);
            filterList.css('overflow', 'hidden');
            filterList.addClass('is-hidden');
            filterList.css('opacity', '1');
        } else if (itemsHeight !== filterList.outerHeight() && filterList.hasClass('is-hidden')) {
            filterList.css('height', itemsHeight);
        } else {
            filterList.css('opacity', '1');
            if(countItems <= maxCount)
                tableContainer.find('.js-filter-list-show').addClass('is-hidden');
        }

        tableContainer.find('.js-filter-list-show').click(function (e) {
            e.preventDefault();

            if (filterList.hasClass('is-hidden')) {
                tableContainer.find('.js-filter-list-show').find('span').text("Скрыть");
                filterList.animate({
                    height: '100%'
                }, 'slow', function () {
                    filterList.css('overflow', 'inherit');
                    filterList.removeClass('is-hidden');
                });
            } else {
                tableContainer.find('.js-filter-list').animate({
                    height: itemsHeight
                }, 'slow', function () {
                    filterList.css('overflow', 'hidden');
                    filterList.addClass('is-hidden');
                    tableContainer.find('.js-filter-list-show').find('span').text("Показать ещё");
                    tableContainer.scrollTop(200);
                });
            }
        });

    },
    template: `
        <div v-if="item.VALUES && Object.keys(item.VALUES).length" class="filter__item js-filter-item" :class="{'is-open': open === true}">
            <div class="filter__item-entry js-filter-entry" @click="$emit('processFilterItemView', $event, item.ID)">
                <div class="filter__item-entry-title">{{ item.NAME }}</div>
                <div class="filter__item-entry-arrow">
                    <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                </div>
            </div>
            <div class="filter__item-list js-filter-list-wp" :style="{display: (open === undefined || !open ? 'none' : '')}">
                <div class="filter__item-list-wp js-filter-list">
                    <label v-for="val in item.VALUES" :key="val.CONTROL_ID" :for="val.CONTROL_ID" :class="{disabled: val.DISABLED}" class="filter__item-checkbox js-filter-list-item">
                        <input @change="$emit('setFilter')" :id="val.CONTROL_ID" :checked="val.CHECKED" :name="val.CONTROL_NAME" type="checkbox" :value="val.HTML_VALUE">
                        <span class="filter__item-checkbox-value">{{ val.VALUE }}</span>
                    </label>
                </div>
                <a href="#" data-skip="y" class="filter-show-more js-filter-list-show">
                    <span>Показать ещё</span>
                    <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                </a>
            </div>
        </div>
    `
}